import toastr from "../../../vendor/assets/javascripts/metronic/toastr";

export default toastr;
